
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/teacher/classroom-data",
      function () {
        return require("private-next-pages/reports/teacher/classroom-data/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/teacher/classroom-data"])
      });
    }
  